/**
 * SecoMapp free gifts — bundle page 25572 only.
 *
 * BOGOS adds bundle items on Checkout click, then applies the discount in a
 * follow-up cart request. We wait for cart activity to settle and a discount
 * to appear before redirecting to /checkout.
 *
 * Never modify native .bogos-bp-button-add innerHTML — BOGOS owns that button.
 */
(function () {
  'use strict';

  var BUNDLE_PATH = '/apps/secomapp_freegifts_get_order/bundle/25572';
  var CLAIM_BTN_ATTR = 'data-lm-claim-bundle';
  var CUSTOM_LABEL_ATTR = 'data-lm-label-key';
  var NATIVE_HOOK_ATTR = 'data-lm-cart-hook';

  var syncTimer = null;
  var checkoutAwaitingRedirect = false;
  var checkoutFallbackTimer = null;
  var checkoutSettleTimer = null;
  var checkoutPollTimer = null;
  var checkoutBaselineItemCount = 0;
  var lastHeaderCartCount = null;
  var checkoutRedirectInFlight = false;

  /** Wait after last cart API call before evaluating (BOGOS applies discount after add). */
  var CHECKOUT_SETTLE_MS = 1800;
  /** Keep polling cart.js for discount while checkout is in progress. */
  var CHECKOUT_POLL_MS = 450;
  /** Hard cap — redirect with whatever is in cart if discount never detected. */
  var CHECKOUT_MAX_WAIT_MS = 12000;

  function isBundlePage() {
    return window.location.pathname.indexOf(BUNDLE_PATH) !== -1;
  }

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function findNativeAddButton() {
    var widget = document.querySelector('.bogos-bp-widget');
    if (!widget) return null;
    var buttons = widget.querySelectorAll('.bogos-bp-button-add');
    for (var i = 0; i < buttons.length; i++) {
      if (!buttons[i].hasAttribute(CLAIM_BTN_ATTR)) return buttons[i];
    }
    return null;
  }

  function getHeaderCartCountEl() {
    return (
      document.querySelector('.header__cart-count cart-count') ||
      document.querySelector('store-header cart-count') ||
      document.querySelector('header cart-count')
    );
  }

  function readHeaderCartCount() {
    var el = getHeaderCartCountEl();
    if (!el) return 0;

    try {
      if (typeof el.itemCount === 'number' && !isNaN(el.itemCount)) {
        return el.itemCount;
      }
    } catch (err) {
      /* ignore */
    }

    var hidden = el.querySelector('[aria-hidden="true"]');
    var text = hidden ? hidden.textContent : el.textContent;
    var count = parseInt(String(text || '').replace(/\D/g, ''), 10);
    return isNaN(count) ? 0 : count;
  }

  function getBundleWidgetCount() {
    var widget = document.querySelector('.bogos-bp-widget');
    if (!widget) return 0;
    var countEl = widget.querySelector('.bogos-bp-widget-count');
    if (!countEl) return 0;
    var count = parseInt(String(countEl.textContent || '').replace(/\D/g, ''), 10);
    return isNaN(count) ? 0 : count;
  }

  function parseDiscountPercent(text) {
    if (!text) return null;
    var match = String(text).replace(/\s+/g, ' ').trim().match(/(\d+)\s*%\s*OFF/i);
    return match ? match[1] : null;
  }

  function readDiscountPercent(nativeBtn) {
    if (!nativeBtn || nativeBtn.disabled) return null;

    // Only read the native checkout button — header text includes all tier
    // labels (5%, 10%, 25%…) and would show the wrong % with one product.
    var percent = parseDiscountPercent(nativeBtn.textContent);
    if (!percent) return null;

    if (getBundleWidgetCount() < 2) return null;

    return percent;
  }

  function buildCheckoutHtml(percent) {
    if (percent) {
      return (
        '<span class="lm-checkout-btn__label">Checkout</span> (<span class="lm-checkout-btn__discount">' +
        percent +
        '% OFF</span>)'
      );
    }
    return '<span class="lm-checkout-btn__label">Checkout</span>';
  }

  function syncCustomButtonLabel(customBtn, percent) {
    if (!customBtn) return;

    var labelKey = percent || 'none';
    var targetHtml = buildCheckoutHtml(percent);

    if (customBtn.getAttribute(CUSTOM_LABEL_ATTR) === labelKey && customBtn.innerHTML.trim() === targetHtml) {
      return;
    }

    customBtn.innerHTML = targetHtml;
    customBtn.setAttribute(CUSTOM_LABEL_ATTR, labelKey);
  }

  function syncButtons(customBtn) {
    var nativeBtn = findNativeAddButton();
    if (!nativeBtn) return;

    var percent = readDiscountPercent(nativeBtn);

    if (customBtn) {
      customBtn.disabled = nativeBtn.disabled;
      customBtn.setAttribute('aria-disabled', nativeBtn.disabled ? 'true' : 'false');
      syncCustomButtonLabel(customBtn, percent);
    }
  }

  function scheduleSync(customBtn) {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncButtons(customBtn);
    }, 120);
  }

  function clearCheckoutAwaiting() {
    checkoutAwaitingRedirect = false;
    if (checkoutFallbackTimer) {
      window.clearTimeout(checkoutFallbackTimer);
      checkoutFallbackTimer = null;
    }
    if (checkoutSettleTimer) {
      window.clearTimeout(checkoutSettleTimer);
      checkoutSettleTimer = null;
    }
    if (checkoutPollTimer) {
      window.clearTimeout(checkoutPollTimer);
      checkoutPollTimer = null;
    }
  }

  function redirectToCheckout() {
    if (checkoutRedirectInFlight) return;
    checkoutRedirectInFlight = true;
    window.location.href = shopifyRoot() + 'checkout';
  }

  function finishCheckoutRedirect() {
    clearCheckoutAwaiting();
    redirectToCheckout();
  }

  function cartHasDiscount(cart) {
    if (!cart) return false;
    if (typeof cart.total_discount === 'number' && cart.total_discount > 0) return true;

    var level = cart.cart_level_discount_applications;
    if (level && level.length > 0) return true;

    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) return true;
      if (item.discounts && item.discounts.length > 0) return true;
      if (typeof item.total_discount === 'number' && item.total_discount > 0) return true;
    }
    return false;
  }

  function evaluateCartAndMaybeRedirect(forceFallback) {
    if (!checkoutAwaitingRedirect && !forceFallback) return;

    fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!checkoutAwaitingRedirect && !forceFallback) return;

        var itemCount = cart.item_count || 0;
        var hasDiscount = cartHasDiscount(cart);
        var hasNewItems = itemCount > checkoutBaselineItemCount || itemCount > 0;

        if (hasDiscount && hasNewItems) {
          finishCheckoutRedirect();
          return;
        }

        if (forceFallback && hasNewItems) {
          finishCheckoutRedirect();
          return;
        }

        if (checkoutAwaitingRedirect) {
          scheduleCheckoutPoll();
        }
      })
      .catch(function () {
        if (checkoutAwaitingRedirect) scheduleCheckoutPoll();
        else if (forceFallback) finishCheckoutRedirect();
      });
  }

  function scheduleCheckoutPoll() {
    if (!checkoutAwaitingRedirect) return;
    if (checkoutPollTimer) window.clearTimeout(checkoutPollTimer);
    checkoutPollTimer = window.setTimeout(function () {
      evaluateCartAndMaybeRedirect(false);
    }, CHECKOUT_POLL_MS);
  }

  /** BOGOS often chains add → apply discount; debounce until requests stop. */
  function noteCartActivity() {
    if (!checkoutAwaitingRedirect) return;
    if (checkoutSettleTimer) window.clearTimeout(checkoutSettleTimer);
    checkoutSettleTimer = window.setTimeout(function () {
      evaluateCartAndMaybeRedirect(false);
    }, CHECKOUT_SETTLE_MS);
  }

  function handleCartCountIncrease(previousCount, nextCount) {
    if (nextCount <= previousCount) return;
    lastHeaderCartCount = nextCount;
    if (!checkoutAwaitingRedirect) return;
    noteCartActivity();
  }

  function watchHeaderCartCount() {
    var el = getHeaderCartCountEl();
    if (!el || el.hasAttribute('data-lm-cart-count-watch')) return;
    el.setAttribute('data-lm-cart-count-watch', 'true');

    if (lastHeaderCartCount === null) {
      lastHeaderCartCount = readHeaderCartCount();
    }

    function checkCount() {
      var next = readHeaderCartCount();
      handleCartCountIncrease(lastHeaderCartCount, next);
      if (next !== lastHeaderCartCount) {
        lastHeaderCartCount = next;
      }
    }

    var observer = new MutationObserver(checkCount);
    observer.observe(el, {
      childList: true,
      subtree: true,
      characterData: true
    });

    var headerWrap = el.closest('.header__cart-count') || el.parentElement;
    if (headerWrap && headerWrap !== el) {
      observer.observe(headerWrap, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    window.setInterval(checkCount, 250);
  }

  function beginCheckoutRedirectWatch() {
    checkoutAwaitingRedirect = true;
    checkoutBaselineItemCount = readHeaderCartCount();

    fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        checkoutBaselineItemCount = cart.item_count || checkoutBaselineItemCount;
      })
      .catch(function () {
        /* keep header baseline */
      });

    if (checkoutFallbackTimer) window.clearTimeout(checkoutFallbackTimer);
    checkoutFallbackTimer = window.setTimeout(function () {
      if (checkoutAwaitingRedirect) {
        evaluateCartAndMaybeRedirect(true);
      }
    }, CHECKOUT_MAX_WAIT_MS);

    scheduleCheckoutPoll();
  }

  function isCartApiUrl(url) {
    if (!url) return false;
    return /\/cart\/(add|update|change)(\.js)?(\?|$)/.test(String(url));
  }

  function isCheckoutActivityUrl(url) {
    if (!url) return false;
    var s = String(url);
    if (isCartApiUrl(s)) return true;
    return /\/cart\.js(\?|$)|\/discount\/|freegift|secomapp|bogos|25572/i.test(s);
  }

  function installCartApiIntercept() {
    if (window.__lmBundleCartIntercept) return;
    window.__lmBundleCartIntercept = true;

    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        var promise = nativeFetch.apply(this, arguments);
        if (!checkoutAwaitingRedirect) return promise;

        var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
        if (!isCheckoutActivityUrl(url)) return promise;

        return promise.then(function (response) {
          if (!checkoutAwaitingRedirect || !response.ok) return response;
          noteCartActivity();
          return response;
        });
      };
    }

    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__lmBundleOpen) {
      var nativeOpen = XMLHttpRequest.prototype.open;
      var nativeSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__lmBundleUrl = url;
        return nativeOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        if (checkoutAwaitingRedirect && isCheckoutActivityUrl(xhr.__lmBundleUrl)) {
          xhr.addEventListener('load', function () {
            if (!checkoutAwaitingRedirect || xhr.status < 200 || xhr.status >= 300) return;
            noteCartActivity();
          });
        }
        return nativeSend.apply(this, arguments);
      };

      XMLHttpRequest.prototype.__lmBundleOpen = true;
    }
  }

  function hookNativeCheckoutButton() {
    var widget = document.querySelector('.bogos-bp-widget');
    if (!widget || widget.hasAttribute(NATIVE_HOOK_ATTR)) return;
    widget.setAttribute(NATIVE_HOOK_ATTR, 'true');

    widget.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest ? e.target.closest('.bogos-bp-button-add') : null;
        if (!btn || btn.hasAttribute(CLAIM_BTN_ATTR) || btn.disabled) return;
        installCartApiIntercept();
        beginCheckoutRedirectWatch();
      },
      true
    );
  }

  function triggerNativeCheckout(nativeBtn) {
    installCartApiIntercept();
    beginCheckoutRedirectWatch();
    nativeBtn.click();
  }

  function bindClaimButton(customBtn) {
    customBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (customBtn.disabled) return;

      var nativeBtn = findNativeAddButton();
      if (!nativeBtn || nativeBtn.disabled) return;

      triggerNativeCheckout(nativeBtn);
    });
  }

  function watchNativeAddButton(customBtn) {
    var nativeObserver = null;
    var observedBtn = null;

    function attachNativeObserver() {
      var nativeBtn = findNativeAddButton();
      if (!nativeBtn) return;

      if (nativeBtn !== observedBtn) {
        if (nativeObserver) nativeObserver.disconnect();
        observedBtn = nativeBtn;
        nativeObserver = new MutationObserver(function () {
          scheduleSync(customBtn);
        });
        nativeObserver.observe(nativeBtn, {
          attributes: true,
          attributeFilter: ['disabled', 'class', 'aria-disabled']
        });
      }

      scheduleSync(customBtn);
    }

    attachNativeObserver();

    var domObserver = new MutationObserver(function () {
      attachNativeObserver();
    });

    var widget = document.querySelector('.bogos-bp-widget');
    if (widget) {
      domObserver.observe(widget, { childList: true, subtree: true });
    }
  }

  function injectClaimBundleButton(header) {
    if (!header || header.querySelector('[' + CLAIM_BTN_ATTR + ']')) return null;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'lm-claim-bundle-btn';
    button.disabled = true;
    button.innerHTML = buildCheckoutHtml(null);
    button.setAttribute(CLAIM_BTN_ATTR, 'true');

    bindClaimButton(button);
    header.appendChild(button);
    watchNativeAddButton(button);
    return button;
  }

  function isElementVisible(el) {
    if (!el || !document.contains(el)) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function isBogosPopupOpen() {
    var modal = document.querySelector('.bogos-product-detail-modal');
    if (modal && isElementVisible(modal)) return true;

    modal = document.querySelector('[class*="bogos"][aria-modal="true"]');
    if (modal && isElementVisible(modal)) return true;

    return false;
  }

  function updatePopupOpenState() {
    document.documentElement.classList.toggle('freegifts-bundle-25572--popup-open', isBogosPopupOpen());
  }

  function watchBogosPopup() {
    updatePopupOpenState();
    var observer = new MutationObserver(updatePopupOpenState);
    var root = document.querySelector('.bogos-bp-widget') || document.body;
    if (root) {
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'open', 'aria-modal']
      });
    }
    window.addEventListener('resize', updatePopupOpenState);
  }

  function waitForHeaderCartCount(cb, attempt) {
    if (getHeaderCartCountEl()) {
      cb();
      return;
    }
    if (attempt >= 80) return;
    window.setTimeout(function () {
      waitForHeaderCartCount(cb, attempt + 1);
    }, 100);
  }

  function onWidgetHeaderReady(header) {
    var claimBtn = injectClaimBundleButton(header);
    hookNativeCheckoutButton();
    watchBogosPopup();
    waitForHeaderCartCount(watchHeaderCartCount, 0);
    if (claimBtn) scheduleSync(claimBtn);
  }

  function waitForWidgetHeader(cb) {
    var header = document.querySelector('.bogos-bp-widget-header');
    if (header) {
      cb(header);
      return;
    }

    var attempts = 0;
    var maxAttempts = 120;
    var observer = null;

    function finish() {
      window.clearInterval(poll);
      if (observer) observer.disconnect();
      cb(document.querySelector('.bogos-bp-widget-header'));
    }

    var poll = window.setInterval(function () {
      attempts += 1;
      header = document.querySelector('.bogos-bp-widget-header');
      if (header) {
        finish();
      } else if (attempts >= maxAttempts) {
        finish();
      }
    }, 50);

    if (document.body) {
      observer = new MutationObserver(function () {
        header = document.querySelector('.bogos-bp-widget-header');
        if (header) finish();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    if (!isBundlePage()) return;

    document.documentElement.classList.add('freegifts-bundle-25572');
    installCartApiIntercept();
    waitForWidgetHeader(onWidgetHeaderReady);

    var nativePoll = window.setInterval(function () {
      var nativeBtn = findNativeAddButton();
      if (!nativeBtn) return;
      window.clearInterval(nativePoll);
      syncButtons(document.querySelector('[' + CLAIM_BTN_ATTR + ']'));
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
